module.exports = __webpack_public_path__ + "img/telehealth.e2ac3f12.svg";